import React, { useEffect } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Helmet } from "react-helmet";
import Banner from "../assets/images/privacy-policy/Banner.webp";

const AppPrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title> App Privacy Policy | Huntsville Islamic Center</title>
        <script src="https://widget-cdn.simplepractice.com/assets/integration-1.0.js"></script>
      </Helmet>
      <section id="website-responsive" className="px-0">
        <section
          className="container-fluid bg-common-banner"
          style={{ backgroundImage: `url(${Banner})` }}
        >
          <Header />
          <div className="fs-banner-title text-white fw-500 text-center py-5">
            <div className="py-md-5 mb-md-5">App Privacy Policy</div>
          </div>
        </section>
        <div className="py-4 py-md-5" />

        <section className="container-fluid">
          <div className="row justify-content-evenly">
            <div className="col-11 col-md-10 mx-auto">
              <div className="pb-4">
                <div className="text-dark fs-ss-18 fw-400">
                  At Huntsville Islamic Center (“HIC,” “we,” “our,” or “us”), we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains what information we collect, how we use it, and how we safeguard it when you use the HIC Mobile App (the “App”). 
                  <div className="py-2"/>
                  By using the App, you agree to the collection and use of information in accordance with this Privacy Policy. 
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  1. Information We Collect
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                 We collect information to provide, improve, and personalize your experience in the HIC App. 
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-20 lh-sm fw-600">
                  (a) Personal Information 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  When you register or log in to the App, we may collect: 
                  <ul className="mt-2">
                    <li>
                      Name, Email address (used for account creation and verification), Phone number, Date of birth, Gender and Profile photo (optional). 
                    </li>
                    <li>
                      Login details (if you choose to sign in with Google or Apple). 
                    </li>
                    <li>
                      Profile information you provide (e.g., name updates, contact number). 
                    </li>
                    <li>
                      Donation information (processed securely through Square; we do not store your payment card details). 
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-20 lh-sm fw-600">
                  (b) Location Information 
                </div>
                <div className="text-dark fs-ss-18 fw-400"> 
                  <ul className="mt-2">
                    <li> Your location is used only for the Qibla finder feature to show accurate prayer direction. </li>
                    <li> Location data is not stored or shared with any third party. </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-20 lh-sm fw-600">
                 (c) Business Directory Information 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  <ul className="mt-2">
                    <li> When you submit your business for listing, we collect the business name, contact details, category, description and some other information. </li>
                    <li> Once approved by the admin, your business details become visible to other users within the App. </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-20 lh-sm fw-600">
                 (d) Information from Third-Party Services 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  <ul className="mt-2">
                    <li> The App may display data or integrate with third-party tools such as: </li>
                    <li> Google Calendar (to display HIC's event calendar) </li>
                    <li> Square (for processing donations) </li>
                    <li> Google Maps (for Masjid location display) </li>
                    <li> Social Media Links (for communication and updates) </li>
                  </ul>
                  These third-party services operate under their own privacy policies, and we encourage you to review them separately.
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-20 lh-sm fw-600">
                 (e) App Usage & Device Data  
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We may collect limited technical information such as: 
                  <ul className="mt-2">
                    <li>
                      Device type, operating system, IP address, and app usage logs. 
                    </li>
                    <li>
                      Error reports or diagnostics to improve app performance.  
                    </li>
                    <li>
                      Cookies and similar technologies to improve user experience. 
                    </li>
                  </ul>
                  </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-20 lh-sm fw-600">
                  (f) Communication Data 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  <ul className="mt-2">
                    <li>
                      Records of inquiries, feedback, or support requests you send through the App.  
                    </li>
                    <li>
                      Notifications related to events, announcements, or updates from HIC. 
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  2. How We Use Your Information 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  Your information is used solely for community and service-related purposes, including to: 
                  <ul className="mt-2">
                    <li>
                      Create and manage your user account. 
                    </li>
                    <li>
                      Verify your email using an OTP code for secure login. 
                    </li>
                    <li>
                      Display accurate prayer times, Qibla direction, and HIC announcements. 
                    </li>
                    <li>
                      Allow you to view and register for events, including recurring and multi-day events.  
                    </li>
                    <li>
                      Enable to add and manage business listings pending admin approval. 
                    </li>
                    <li>
                      Notify you of important community announcements (e.g., Eid, events, job postings).  
                    </li>
                    <li>
                      Facilitate donations securely through our Square integration. 
                    </li>
                    <li>
                      Improve App functionality, resolve technical issues, and analyze user engagement. 
                    </li>
                  </ul>
                  </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  3. How We Share Information 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We do not sell or share your personal information with advertisers or unrelated third parties. We only share data when necessary, including: 
                  <ul className="mt-2">
                    <li>
                      With Service Providers: Trusted third parties such as payment processors (e.g., Square) or hosting providers that help us operate the App. 
                    </li>
                    <li>
                      With Your Consent: When you choose to make your business public in the Business Directory. 
                    </li>
                    <li>
                      As Required by Law: When disclosure is necessary to comply with legal obligations or protect HIC's rights and property. 
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  4. Data Protection & Security 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We implement industry-standard security measures to protect your information, including: 
                  <ul className="mt-2">
                    <li>
                      Encrypted data transmission (SSL/TLS). 
                    </li>
                    <li>
                      Secure servers and restricted administrative access. 
                    </li>
                    <li>
                      No storage of payment card information (handled securely by Square). 
                    </li>
                  </ul>
                  While we strive to protect your personal data, no electronic system is completely secure. You use the App at your own discretion and risk. 
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  5. Data Retention 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We retain your data only for as long as necessary to: 
                  <ul className="mt-2">
                    <li>
                      Maintain your account and provide App features. 
                    </li>
                    <li>
                      Comply with applicable U.S. laws and regulations. 
                    </li>
                    <li>
                      Resolve disputes or enforce our agreements. 
                    </li>
                  </ul>
                  You may request deletion of your account and related data at any time and can recover your account by contacting us (see Section 9). 
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  6. Your Rights 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  As a user, you have the right to: 
                  <ul className="mt-2">
                    <li>
                      Access the personal information we hold about you. 
                    </li>
                    <li>
                      Request correction or deletion of your data. 
                    </li>
                    <li>
                      Withdraw consent to certain processing (e.g., stop receiving announcement notifications).  
                    </li>
                    <li>
                      Request information about how your data is used and shared. 
                    </li>
                  </ul>
                  To exercise any of these rights, contact us using the details provided below.
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  7. Permissions & Device Access 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  The App may request access to the following: 
                  <ul className="mt-2">
                    <li>
                      Location Access: Required for accurate Qibla direction. 
                    </li>
                    <li>
                      Notifications: To alert you about prayer times, events, and community announcements. 
                    </li>
                    <li>
                      Camera Access: To capture your profile picture or documents. 
                    </li>
                    <li>
                      Storage Access: To save or retrieve limited data related to your profile or business listing. 
                    </li>
                  </ul>
                  You may disable permissions anytime through your device settings; however, certain features may not function properly without them. 
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  8. Donations and Payments  
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  All donations made through the App are processed by Square, a secure third-party payment processor. 
                  <ul className="mt-2">
                    <li>
                      HIC does not store or access your credit/debit card information. 
                    </li>
                    <li>
                      Square's own privacy policy applies to payment processing; we recommend reviewing it before donating.
                    </li>
                  </ul>
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  9. Children's Privacy 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  The HIC App is intended for general community use and is not directed toward children under 13. We do not knowingly collect personal data from children. 
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  10. Delete Account 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  Users can delete their account directly from within the App. Once an account is deleted, all associated data and access to the App will be temporarily disabled, and the user will no longer be able to log in. 
                  <div className="py-2" />
                  HIC maintains a 30-day retention period following deletion, during which users may contact the HIC support team to request account recovery. If the account is restored within this period, users can regain access to their profile and previous data. 
                  <div className="py-2" />
                  After the 30-day period expires, the account and all related data will be permanently deleted and cannot be recovered. 
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  11. Changes to This Privacy Policy  
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  We may update this Privacy Policy periodically to reflect changes in our practices or for legal and operational reasons. The revised version will be updated here. 
                  <div className="py-2" />
                  Continued use of the App after changes take effect indicates your acceptance of the updated policy.
                </div>
              </div>

                            <div className="pb-4">
                <div className="pb-2 text-dark fs-ss-24 lh-sm fw-600">
                  12. Contact Us 
                </div>
                <div className="text-dark fs-ss-18 fw-400">
                  If you have any questions, concerns, or requests regarding this Privacy Policy or how your data is handled, please contact us at:
                  <div className="fw-500 pt-2">
                    Huntsville Islamic Center (HIC)  
                  </div>
                  <div className="py-2" />
                  <ul className="mt-2">
                    <li>
                      <a href="https://www.google.com/maps/place/Huntsville+Islamic+Center/@34.7426316,-86.6486421,17z/data=!4m6!3m5!1s0x88626beee4aecde7:0xb7695647cfc648ed!8m2!3d34.7426184!4d-86.6486663!16s%2Fg%2F1thtdw85?entry=ttu&g_ep=EgoyMDI1MTAxNC4wIKXMDSoASAFQAw%3D%3D" className="text-decoration-none text-dark" target="_blank">1645 Sparkman Dr NW, Huntsville, AL 35816, USA</a> 
                    </li>
                    <li>
                      <a href="mailto:board@huntsvilleislamiccenter.org" className="text-decoration-none text-dark">board@huntsvilleislamiccenter.org</a> 
                    </li>
                    <li>
                      <a href="https://huntsvilleislamiccenter.org/" className="text-decoration-none text-dark">https://huntsvilleislamiccenter.org</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="py-4 py-md-5" />

        <Footer />
      </section>
    </>
  );
};

export default AppPrivacyPolicy;
